<!-- Header -->
<div class="flex justify-between items-center mb-6">
  <div>
    <h2 class="text-2xl font-semibold text-gray-800">Bookings Management</h2>
    <p class="text-sm text-gray-500 mt-1">Manage and track all service bookings.</p>
  </div>
  <button
    (click)="loadBookings()"
    class="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700 transition">
    <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round"
        d="M4 4v5h.582M20 20v-5h-.581M5.635 19A9 9 0 104.582 9H4" />
    </svg>
    Refresh
  </button>
</div>

<!-- Loading Spinner -->
<div *ngIf="isLoading" class="flex justify-center items-center py-20">
  <div class="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
</div>

<!-- Error State -->
<div *ngIf="!isLoading && errorMessage"
  class="flex items-center gap-3 bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-6">
  <svg class="w-5 h-5 shrink-0" fill="currentColor" viewBox="0 0 20 20">
    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm-.75-9.25a.75.75 0 011.5 0v3.5a.75.75 0 01-1.5 0v-3.5zm.75 6a.75.75 0 100-1.5.75.75 0 000 1.5z" clip-rule="evenodd" />
  </svg>
  <span>{{ errorMessage }}</span>
  <button (click)="loadBookings()" class="ml-auto text-sm underline">Retry</button>
</div>

<div class="space-y-6" *ngIf="!isLoading && !errorMessage">

  <!-- Filters -->
  <div class="bg-white p-4 rounded-2xl shadow flex gap-4 items-center">
    <input
      type="text"
      placeholder="Search by ID, User, Mechanic..."
      class="border rounded-lg px-3 py-2 w-80" />

    <select class="border rounded-lg px-3 py-2">
      <option>All Status</option>
      <option>Pending</option>
      <option>Accepted</option>
      <option>In Progress</option>
      <option>Completed</option>
      <option>Cancelled</option>
    </select>

    <button class="px-4 py-2 bg-blue-600 text-white rounded-lg">
      Filter
    </button>
  </div>

  <!-- Table -->
  <div class="bg-white rounded-2xl shadow overflow-hidden">
    <table class="w-full text-sm">
      <thead class="bg-gray-100 text-left">
        <tr>
          <th class="p-4">Booking ID</th>
          <th>User</th>
          <th>Mechanic</th>
          <th>Service</th>
          <th>Area</th>
          <th>Date</th>
          <th>Amount</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let booking of bookings"
            class="border-t hover:bg-gray-50">

          <td class="p-4 font-medium text-blue-600">
            #{{ booking.id }}
          </td>

          <td>{{ booking.user }}</td>
          <td>{{ booking.mechanic }}</td>
          <td>{{ booking.service }}</td>
          <td>{{ booking.area }}</td>
          <td>{{ booking.date | date:'mediumDate' }}</td>
          <td>${{ booking.amount | number:'1.2-2' }}</td>

          <td>
            <app-badge [color]="getBadgeColor(booking.status)">
              {{ booking.status }}
            </app-badge>
          </td>

          <td>
            <button
              (click)="viewBooking(booking)"
              class="p-2 text-gray-500 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition" title="View Details">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path stroke-linecap="round" stroke-linejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
            </button>
          </td>

        </tr>
        <tr *ngIf="bookings.length === 0">
          <td colspan="9" class="p-8 text-center text-gray-500">No bookings found.</td>
        </tr>
      </tbody>
    </table>
  </div>

</div>